import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Form from "../Form/Form";

const ModifyRace = () => {
  const { modifyId } = useParams();
  const navigate = useNavigate();
  const { allDogs, lenguage } = useSelector((state) => state);
  const [updateRace, setUpdateRace] = useState();
  useEffect(() => {
    !modifyId && navigate("/home");
    const race = allDogs.find((dog) => dog.id === modifyId);
    setUpdateRace(race);
  }, [modifyId]); //eslint-disable-line

  return (
    <>
    <br />
      <h1>{lenguage?"MODIFY BREED":"MODIFICAR RAZA"}</h1>
      <Form updateDog={updateRace} />
    </>
  );
};
export default ModifyRace;
